@if (setupComplete()) {
  <header>
    <rf-navbar/>
  </header>
  <rf-toasts-overlay aria-live="polite" aria-atomic="true"/>
  <main class="main-content container-fluid">
    <router-outlet/>
  </main>
  <footer>
    <rf-footer/>
  </footer>
} @else {
  <div class="position-absolute top-50 start-50 translate-middle">
    <rf-loading-indicator/>
  </div>
}
